import { render, staticRenderFns } from "./TournamentStatus.vue?vue&type=template&id=01932d22&scoped=true"
import script from "./TournamentStatus.vue?vue&type=script&lang=js"
export * from "./TournamentStatus.vue?vue&type=script&lang=js"
import style0 from "./TournamentStatus.vue?vue&type=style&index=0&id=01932d22&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01932d22",
  null
  
)

export default component.exports